<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container lg">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">{{ state.windowTitle }}</span>
        </div>

        <div class="popup-content">

          <FontawesomeIcon v-if="!state.isDataLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
          <template v-else>
            <p v-if="state.allList.length === 0">共有されたアカウントがありません。</p>
            <template v-else>
              <form @submit.prevent="state.search">
                <div class="formparts function suggest">
                  <input v-model="state.search_text" type="text" placeholder="キーワード">
                  <div @click="state.search" class="button" role="button"><FontawesomeIcon icon="search" class="icn" /></div>
                  <ul class="suggest-list">
                    <li v-for="(item, index) in state.list" :key="'user_' + index"
                      v-show="item.id !== state.profileId">
                      <label>{{ item.name }}</label>
                    </li>
                  </ul>
                </div>
              </form>
            </template>
          </template>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

import { NoteUserPermissionsList } from '@/logic/note/NoteUserPermissionsList'

export default defineComponent({
  name: 'PCNoteUserPermissionsList',
  setup (props, context) {
    return {
      ...NoteUserPermissionsList(props, context)
    }
  }
})
</script>

<style lang="scss" scoped>
.popup-content {
  .button .btn {
    width: 232px;
    margin-right: auto;
    margin-left: auto;
  }
  .suggest-list {

    // input[type="checkbox"]:checked + label .icn {
    //   opacity: 1;
    // }
    label {
      position: relative;
      padding-left: 19px;
      // &:before {
      //   content: '';
      //   position: absolute;
      //   top: 11px;
      //   border-radius: 4px;
      //   left: 20px;
      //   width: 20px;
      //   height: 20px;
      //   background-color: $color-bg-form;
      // }
      // .icn {
      //   font-size: 1.4rem;
      //   position: absolute;
      //   top: 15px;
      //   left: 23px;
      //   color: $color-link;
      //   opacity: 0;
      // }
    }
  }
}
</style>
